import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '80%',
    maxHeight: '80%',
  });

export default function CustomizedDialogs({ isOpenDialog, onClickClose }) {

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={onClickClose}
        aria-labelledby="customized-dialog-title"
        open={isOpenDialog}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          扫码购买
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClickClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
            <Img alt="Picture" src="https://creatorspace.imgix.net/users/clvmdgr2j026um901z4xjeygr/Ytem1lfR1joQlrh7-IMG_2235.JPG?w=750&h=750"></Img>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={onClickClose} sx={{backgroundColor: '#D5AD70', color: 'white', borderRadius: '0px'}}>
            OK
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
